"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SofProcessor = void 0;
var Helper_1 = require("./Helper");
var PersistentDataService_1 = require("./PersistentDataService");
var SofProcessor = /** @class */ (function () {
    function SofProcessor(currentUser) {
        this.logTime = "";
        this.surveyor = undefined;
        this.lineHandling = {};
        this.nomination = undefined;
        this.activityLogs = [];
        this.processFlowConfigs = [];
        this.processFlowConfig = {};
        this.processFlowState = {};
        this.processFlowStep = {};
        this.processFlowAction = {};
        this.updatedActivityLogs = [];
        this.currentUser = currentUser;
    }
    // Initializes subject Line Handling or Nomination
    SofProcessor.prototype.initializeNominationAsync = function (lineHandlingNo, nominationNo) {
        if (nominationNo === void 0) { nominationNo = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            var _lineHandling, _processFlowConfigs, _activityLogs, _nomination_1, _processFlowConfig, _processFlowState, _processFlowConfig, _processFlowState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, PersistentDataService_1.PersistentDataService.getLineHandlingAsync(lineHandlingNo)];
                    case 1:
                        _lineHandling = _a.sent();
                        if (_lineHandling === undefined)
                            throw new Error("No offline data for Line Handling ".concat(lineHandlingNo));
                        this.lineHandling = _lineHandling;
                        return [4 /*yield*/, PersistentDataService_1.PersistentDataService.getProcessFlowConfigurationsAsync()];
                    case 2:
                        _processFlowConfigs = _a.sent();
                        if (_processFlowConfigs === undefined)
                            throw new Error("No offline configuration found");
                        this.processFlowConfigs = _processFlowConfigs;
                        return [4 /*yield*/, PersistentDataService_1.PersistentDataService.getActivityLogsAsync(lineHandlingNo)];
                    case 3:
                        _activityLogs = _a.sent();
                        if (_activityLogs === undefined)
                            throw new Error("Activity logs for the Line Handling ".concat(lineHandlingNo, " not found"));
                        this.activityLogs = _activityLogs;
                        if (nominationNo) {
                            _nomination_1 = _lineHandling.nominations.find(function (f) { return f.nominationNo.toLowerCase() === nominationNo.toLowerCase(); });
                            if (_nomination_1 === undefined)
                                throw new Error("Nomination ".concat(nominationNo, " does not exists in Line Handling ").concat(lineHandlingNo));
                            this.nomination = _nomination_1;
                            _processFlowConfig = _processFlowConfigs.find(function (f) {
                                return f.id === _nomination_1.processFlowConfigId &&
                                    f.version === _nomination_1.processFlowConfigVersion;
                            });
                            if (_processFlowConfig) {
                                this.processFlowConfig = _processFlowConfig;
                                _processFlowState = _processFlowConfig.states.find(function (f) { return f.name === _nomination_1.currentState; });
                                if (_processFlowState === undefined)
                                    throw new Error("Nomination's state not found in configuration");
                                this.processFlowState = _processFlowState;
                            }
                        }
                        else {
                            _processFlowConfig = _processFlowConfigs.find(function (f) {
                                return f.id === _lineHandling.processFlowConfigId &&
                                    f.version === _lineHandling.processFlowConfigVersion;
                            });
                            if (_processFlowConfig === undefined)
                                throw new Error("No offline configuration found for Line Handling ".concat(lineHandlingNo));
                            this.processFlowConfig = _processFlowConfig;
                            _processFlowState = _processFlowConfig.states.find(function (f) { return f.name === _lineHandling.currentState; });
                            if (_processFlowState === undefined)
                                throw new Error("Nomination's state not found in configuration");
                            this.processFlowState = _processFlowState;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SofProcessor.prototype.executeAction = function (e) {
        this.logTime = e.executionTime; // moment(e.executionTime).format("L LT");
        this.surveyor = e.surveyor;
        var _processFlowStep = this.processFlowConfig.steps.find(function (f) { return f.id === e.stepId; });
        if (_processFlowStep)
            this.processFlowStep = _processFlowStep;
        else
            throw new Error("Step does not found in the configuration");
        var _processFlowAction = _processFlowStep.actions.find(function (f) { return f.id === e.actionId; });
        if (_processFlowAction)
            this.processFlowAction = _processFlowAction;
        else
            throw new Error("Action does not found in the step");
        this.checkDuplicate(e);
        var actionConditions = _processFlowAction.conditions && _processFlowAction.conditions.split("|");
        if (actionConditions &&
            actionConditions.length > 0 &&
            !this.checkConditions(actionConditions[0])) {
            var message = actionConditions.length > 1
                ? actionConditions[1]
                : "Can't proceed with the action";
            throw new Error(message);
        }
        if (e.surveyor) {
            if (e.inputValues === undefined) {
                e.inputValues = [];
            }
            e.inputValues = __spreadArray(__spreadArray([], e.inputValues, true), [
                {
                    caption: "Surveyor",
                    value: e.surveyor,
                    type: "text",
                },
            ], false);
        }
        var description = SofProcessor.replaceMergeField(this.processFlowAction.name, e.surveyor, e.order, this.lineHandling.vesselType);
        var state = this.nomination !== undefined
            ? this.nomination.currentState
            : this.lineHandling.currentState;
        this.activityLogs = __spreadArray(__spreadArray([], this.activityLogs, true), [
            {
                id: this.generateActivityId(),
                processStepId: e.stepId,
                processActionId: e.actionId,
                lineHandlingNo: this.lineHandling.lineHandlingNo,
                nominationNo: this.nomination && this.nomination.nominationNo,
                description: description,
                logTime: this.logTime,
                state: state,
                status: this.processFlowAction.type,
                inputValues: e.inputValues,
                repetitionOrder: e.order,
                surveyor: e.surveyor,
                performedBy: this.currentUser,
                groupIndex: undefined,
            },
        ], false);
        if (this.nomination !== undefined) {
            this.nomination.currentStep = description;
        }
        else {
            this.lineHandling.currentStep = description;
        }
    };
    SofProcessor.prototype.checkDuplicate = function (e) {
        var _this = this;
        var actionId = this.processFlowStep.actions
            .filter(function (f) {
            return f.displayAt === _this.processFlowAction.displayAt &&
                f.displayConditions === _this.processFlowAction.displayConditions;
        })
            .map(function (f) { return f.id; });
        var stepActivities = this.activityLogs
            .filter(function (f) {
            return f.processStepId === e.stepId &&
                f.nominationNo === e.nominationNo &&
                f.surveyor === e.surveyor &&
                f.repetitionOrder === e.order;
        })
            .sort(function (a, b) { return b.id - a.id; });
        var lastActivity = stepActivities.find(function (f) { return f.status === _this.processFlowAction.displayAt; });
        if (lastActivity === undefined) {
            throw new Error("Action cannot perform at this time. Please refresh the page and try again.");
        }
        if (lastActivity.status !== 0 &&
            new Date(lastActivity.logTime) > new Date(e.executionTime)) {
            throw new Error("Action cannot perform");
        }
        var duplicate = stepActivities.filter(function (f) {
            return f.processActionId !== undefined &&
                actionId.indexOf(f.processActionId) >= 0 &&
                f.nominationNo === e.nominationNo &&
                f.repetitionOrder === e.order &&
                f.surveyor === e.surveyor &&
                f.status !== 5;
        });
        if (duplicate.length > 0 &&
            !(this.processFlowAction.type === 5 ||
                this.processFlowAction.displayAt === 5)) {
            throw new Error("Action conflicts with another action performed earlier. Please refresh the page.");
        }
    };
    // creates the next step in the process flow
    SofProcessor.prototype.processNextStep = function () {
        var _a;
        if (this.processFlowAction.nextSteps) {
            for (var _i = 0, _b = this.processFlowAction.nextSteps; _i < _b.length; _i++) {
                var nextStep = _b[_i];
                if (this.checkConditions(nextStep.conditions)) {
                    var _loop_1 = function (counter) {
                        var stepId = nextStep.stepIds[counter];
                        var step = this_1.processFlowConfig.steps.find(function (f) { return f.id === stepId; });
                        if (step === undefined)
                            return "continue";
                        var startAs = nextStep.startAs !== undefined &&
                            nextStep.startAs.length > counter
                            ? nextStep.startAs[counter]
                            : step.startAs;
                        var state = step.processFlowStateId !== undefined
                            ? (_a = this_1.processFlowConfig.states.find(function (f) {
                                return step &&
                                    step.processFlowStateId &&
                                    f.id === step.processFlowStateId;
                            })) === null || _a === void 0 ? void 0 : _a.name
                            : this_1.nomination === undefined
                                ? this_1.lineHandling.currentState
                                : this_1.nomination.currentState;
                        if (step.name.indexOf("{surveyor}") >= 0 &&
                            this_1.nomination === undefined) {
                            var surveyors = this_1.surveyor === undefined
                                ? this_1.lineHandling.surveyors.split("|")
                                : [this_1.surveyor];
                            for (var _c = 0, surveyors_1 = surveyors; _c < surveyors_1.length; _c++) {
                                var surveyor = surveyors_1[_c];
                                var description = SofProcessor.replaceMergeField(step.name, surveyor, 1, this_1.lineHandling.vesselType);
                                //this.lineHandling.currentStep = description;
                                var inputValues = [
                                    {
                                        caption: "Surveyor",
                                        type: "text",
                                        value: surveyor,
                                    },
                                ];
                                this_1.activityLogs = __spreadArray(__spreadArray([], this_1.activityLogs, true), [
                                    {
                                        id: this_1.generateActivityId(),
                                        lineHandlingNo: this_1.lineHandling.lineHandlingNo,
                                        description: description,
                                        logTime: this_1.logTime,
                                        processStepId: step.id,
                                        state: state,
                                        status: startAs,
                                        repetitionOrder: 1,
                                        inputValues: inputValues,
                                        surveyor: surveyor,
                                        groupIndex: undefined,
                                    },
                                ], false);
                            }
                        }
                        else {
                            var nominationNo_1 = this_1.nomination && this_1.nomination.nominationNo;
                            var stepCount = this_1.activityLogs.filter(function (f) {
                                return f.nominationNo === nominationNo_1 &&
                                    f.processStepId === stepId &&
                                    f.status === startAs;
                            }).length;
                            var description = SofProcessor.replaceMergeField(step.name, undefined, stepCount + 1, this_1.lineHandling.vesselType);
                            // if (this.nomination) {
                            //   this.nomination.currentStep = description;
                            // } else {
                            //   this.lineHandling.currentStep = description;
                            // }
                            this_1.activityLogs = __spreadArray(__spreadArray([], this_1.activityLogs, true), [
                                {
                                    id: this_1.generateActivityId(),
                                    lineHandlingNo: this_1.lineHandling.lineHandlingNo,
                                    description: description,
                                    logTime: this_1.logTime,
                                    processStepId: step.id,
                                    state: state,
                                    status: startAs,
                                    repetitionOrder: stepCount + 1,
                                    groupIndex: undefined,
                                    nominationNo: this_1.nomination && this_1.nomination.nominationNo,
                                },
                            ], false);
                        }
                    };
                    var this_1 = this;
                    for (var counter = 0; nextStep.stepIds.length > counter; counter++) {
                        _loop_1(counter);
                    }
                }
            }
        }
    };
    SofProcessor.prototype.moveState = function () {
        var _this = this;
        var _a;
        if (this.nomination === undefined) {
            var states = this.processFlowConfig.states.filter(function (f) { return f.order > _this.processFlowState.order; });
            for (var _i = 0, states_1 = states; _i < states_1.length; _i++) {
                var state = states_1[_i];
                if (this.checkConditions(state.conditions)) {
                    this.lineHandling.currentState = state.name;
                    this.newState = state.name;
                    for (var _b = 0, _c = state.startStepIds; _b < _c.length; _b++) {
                        var stepsId = _c[_b];
                        if (this.checkConditions(stepsId.conditions)) {
                            var _loop_2 = function (index) {
                                var stepId = stepsId.stepIds[index];
                                var step = this_2.processFlowConfig.steps.find(function (f) { return f.id === stepId; });
                                if (step === undefined)
                                    return "continue";
                                var description = SofProcessor.replaceMergeField(step.name, undefined, 1, this_2.lineHandling.vesselType);
                                var startAs = stepsId.startAs && stepsId.startAs.length > index
                                    ? stepsId.startAs[index]
                                    : step.startAs;
                                this_2.activityLogs = __spreadArray(__spreadArray([], this_2.activityLogs, true), [
                                    {
                                        id: this_2.generateActivityId(),
                                        lineHandlingNo: this_2.lineHandling.lineHandlingNo,
                                        description: description,
                                        logTime: this_2.logTime,
                                        processStepId: step.id,
                                        state: state.name,
                                        status: startAs,
                                        repetitionOrder: 1,
                                        groupIndex: undefined,
                                    },
                                ], false);
                            };
                            var this_2 = this;
                            for (var index = 0; index < stepsId.stepIds.length; index++) {
                                _loop_2(index);
                            }
                        }
                    }
                }
                this.modifyDataI(state.modifyDataConditions, state.modifyData);
            }
            var _loop_3 = function (nom) {
                var nomConfig = this_3.processFlowConfigs.find(function (f) {
                    return f.id === nom.processFlowConfigId &&
                        f.version === nom.processFlowConfigVersion;
                });
                if (nomConfig === undefined)
                    return "continue";
                var nomState = nomConfig.states.find(function (f) { return f.name === nom.currentState; });
                if (nomState === undefined)
                    return "continue";
                var states_5 = nomConfig.states.filter(function (f) { return f.order > nomState.order; });
                var nomActivities = this_3.activityLogs.filter(function (f) { return f.nominationNo === nom.nominationNo; });
                for (var _m = 0, states_4 = states_5; _m < states_4.length; _m++) {
                    var state = states_4[_m];
                    if (SofProcessor.checkConditions(state.conditions, this_3.lineHandling, nom, nomActivities)) {
                        nom.currentState = state.name;
                        for (var _o = 0, _p = state.startStepIds; _o < _p.length; _o++) {
                            var stepsId = _p[_o];
                            if (SofProcessor.checkConditions(stepsId.conditions, this_3.lineHandling, nom, nomActivities)) {
                                var _loop_6 = function (index) {
                                    var stepId = stepsId.stepIds[index];
                                    var step = nomConfig.steps.find(function (f) { return f.id === stepId; });
                                    if (step === undefined)
                                        return "continue";
                                    var description = SofProcessor.replaceMergeField(step.name, undefined, 1, this_3.lineHandling.vesselType);
                                    var startAs = stepsId.startAs && stepsId.startAs.length > index
                                        ? stepsId.startAs[index]
                                        : step.startAs;
                                    var stepState = step.processFlowStateId === state.id
                                        ? state.name
                                        : (_a = nomConfig.states.find(function (f) { return f.id === step.processFlowStateId; })) === null || _a === void 0 ? void 0 : _a.name;
                                    this_3.activityLogs = __spreadArray(__spreadArray([], this_3.activityLogs, true), [
                                        {
                                            id: this_3.generateActivityId(),
                                            lineHandlingNo: this_3.lineHandling.lineHandlingNo,
                                            nominationNo: nom.nominationNo,
                                            description: description,
                                            logTime: this_3.logTime,
                                            processStepId: step.id,
                                            state: stepState,
                                            status: startAs,
                                            repetitionOrder: 1,
                                            groupIndex: undefined,
                                        },
                                    ], false);
                                };
                                for (var index = 0; index < stepsId.stepIds.length; index++) {
                                    _loop_6(index);
                                }
                            }
                        }
                        this_3.modifyDataI(state.modifyDataConditions, state.modifyData, nom);
                        break;
                    }
                }
            };
            var this_3 = this;
            for (var _d = 0, _e = this.lineHandling.nominations; _d < _e.length; _d++) {
                var nom = _e[_d];
                _loop_3(nom);
            }
        }
        else {
            var states = this.processFlowConfig.states.filter(function (f) { return f.order > _this.processFlowState.order; });
            for (var _f = 0, states_2 = states; _f < states_2.length; _f++) {
                var state = states_2[_f];
                var nomActivityLogs = this.activityLogs.filter(function (f) {
                    return f.nominationNo === (_this.nomination && _this.nomination.nominationNo);
                });
                if (SofProcessor.checkConditions(state.conditions, this.lineHandling, this.nomination, nomActivityLogs)) {
                    this.nomination.currentState = state.name;
                    this.newState = state.name;
                    for (var _g = 0, _h = state.startStepIds; _g < _h.length; _g++) {
                        var stepsId = _h[_g];
                        if (this.checkConditions(stepsId.conditions)) {
                            var _loop_4 = function (index) {
                                var stepId = stepsId.stepIds[index];
                                var step = this_4.processFlowConfig.steps.find(function (f) { return f.id === stepId; });
                                if (step === undefined)
                                    return "continue";
                                var description = SofProcessor.replaceMergeField(step.name, undefined, 1, this_4.lineHandling.vesselType);
                                var startAs = stepsId.startAs && stepsId.startAs.length > index
                                    ? stepsId.startAs[index]
                                    : step.startAs;
                                this_4.activityLogs = __spreadArray(__spreadArray([], this_4.activityLogs, true), [
                                    {
                                        id: this_4.generateActivityId(),
                                        lineHandlingNo: this_4.lineHandling.lineHandlingNo,
                                        nominationNo: this_4.nomination.nominationNo,
                                        description: description,
                                        logTime: this_4.logTime,
                                        processStepId: step.id,
                                        state: state.name,
                                        status: startAs,
                                        repetitionOrder: 1,
                                        groupIndex: undefined,
                                    },
                                ], false);
                            };
                            var this_4 = this;
                            for (var index = 0; index < stepsId.stepIds.length; index++) {
                                _loop_4(index);
                            }
                        }
                    }
                    this.lineHandling.nominations = __spreadArray(__spreadArray([], this.lineHandling.nominations.filter(function (f) {
                        return f.nominationNo !==
                            (_this.nomination && _this.nomination.nominationNo);
                    }), true), [
                        this.nomination,
                    ], false);
                    this.modifyDataI(state.modifyDataConditions, state.modifyData, this.nomination);
                }
            }
            var lineHandlingConfig = this.processFlowConfigs.find(function (f) {
                return f.id === _this.lineHandling.processFlowConfigId &&
                    f.version === _this.lineHandling.processFlowConfigVersion;
            });
            if (lineHandlingConfig) {
                var currentState_1 = lineHandlingConfig.states.find(function (f) { return f.name === _this.lineHandling.currentState; });
                if (currentState_1 === undefined)
                    return;
                var states_6 = lineHandlingConfig.states.filter(function (f) { return f.order > currentState_1.order; });
                for (var _j = 0, states_3 = states_6; _j < states_3.length; _j++) {
                    var state = states_3[_j];
                    if (SofProcessor.checkConditions(state.conditions, this.lineHandling, this.nomination, this.activityLogs)) {
                        this.lineHandling.currentState = state.name;
                        for (var _k = 0, _l = state.startStepIds; _k < _l.length; _k++) {
                            var stepsId = _l[_k];
                            if (this.checkConditions(stepsId.conditions)) {
                                var _loop_5 = function (index) {
                                    var stepId = stepsId.stepIds[index];
                                    var step = lineHandlingConfig.steps.find(function (f) { return f.id === stepId; });
                                    if (step === undefined)
                                        return "continue";
                                    var description = SofProcessor.replaceMergeField(step.name, undefined, 1, this_5.lineHandling.vesselType);
                                    var startAs = stepsId.startAs && stepsId.startAs.length > index
                                        ? stepsId.startAs[index]
                                        : step.startAs;
                                    this_5.activityLogs = __spreadArray(__spreadArray([], this_5.activityLogs, true), [
                                        {
                                            id: this_5.generateActivityId(),
                                            lineHandlingNo: this_5.lineHandling.lineHandlingNo,
                                            description: description,
                                            logTime: this_5.logTime,
                                            processStepId: step.id,
                                            state: state.name,
                                            status: startAs,
                                            repetitionOrder: 1,
                                            groupIndex: undefined,
                                        },
                                    ], false);
                                };
                                var this_5 = this;
                                for (var index = 0; index < stepsId.stepIds.length; index++) {
                                    _loop_5(index);
                                }
                            }
                        }
                        this.modifyDataI(state.modifyDataConditions, state.modifyData);
                    }
                }
            }
        }
    };
    SofProcessor.prototype.processOtherAction = function () {
        var _this = this;
        var _a;
        if (this.processFlowAction.otherAction) {
            var actions = this.processFlowAction.otherAction.split(",");
            var _loop_7 = function (action) {
                var regex = /\((.*?)\)/gm;
                var match = [];
                var m = void 0;
                while ((m = regex.exec(action.trim())) !== null) {
                    if (m.index === regex.lastIndex) {
                        regex.lastIndex++;
                    }
                    m.forEach(function (mat) { return (match = __spreadArray(__spreadArray([], match, true), [mat], false)); });
                }
                if (match.length > 1) {
                    var stepId_1 = parseInt(match[1]);
                    var nominationActs = SofProcessor.getCurrentActivityPerStep(this_6.activityLogs).filter(function (f) {
                        return f.processStepId === stepId_1 &&
                            f.nominationNo ===
                                (_this.nomination && _this.nomination.nominationNo);
                    });
                    var distinctNomination = nominationActs
                        .map(function (f) { return f.nominationNo; })
                        .filter(function (n, i, l) { return l.indexOf(n) === i; });
                    if (distinctNomination.length === 0) {
                        distinctNomination = [(_a = this_6.nomination) === null || _a === void 0 ? void 0 : _a.nominationNo];
                    }
                    var _loop_8 = function (_dNom) {
                        var lastActivity = {};
                        var _na = nominationActs.filter(function (f) { return f.nominationNo === _dNom; });
                        if (_na.length === 0) {
                            var step_1 = this_6.processFlowConfig.steps.find(function (f) { return f.id === stepId_1; });
                            if (step_1 === undefined)
                                return "continue";
                            var stepState = "";
                            if (step_1.processFlowStateId === undefined) {
                                stepState =
                                    this_6.nomination === undefined
                                        ? this_6.lineHandling.currentState
                                        : this_6.nomination.currentState;
                            }
                            else {
                                _stepState = this_6.processFlowConfig.states.find(function (f) { return f.id === step_1.processFlowStateId; });
                                if (_stepState === undefined)
                                    return "continue";
                                stepState = _stepState.name;
                            }
                            var description = SofProcessor.replaceMergeField(step_1.name, this_6.surveyor, 1, this_6.lineHandling.vesselType);
                            lastActivity = {
                                lineHandlingNo: this_6.lineHandling.lineHandlingNo,
                                nominationNo: this_6.nomination && this_6.nomination.nominationNo,
                                logTime: this_6.logTime,
                                status: -1,
                                description: description,
                                state: stepState,
                                processStepId: step_1.id,
                                repetitionOrder: 1,
                                surveyor: this_6.surveyor,
                                groupIndex: undefined,
                            };
                        }
                        else {
                            lastActivity = _na[_na.length - 1];
                        }
                        var status_1 = 0;
                        var funct = action
                            .substr(0, action.indexOf("("))
                            .toLowerCase()
                            .trim();
                        if (funct === "start") {
                            status_1 = 1;
                        }
                        else if (funct === "finish") {
                            status_1 = 2;
                        }
                        else if (funct === "skip") {
                            status_1 = 3;
                        }
                        else if (funct === "skipifcreated") {
                            if (lastActivity.status != 0)
                                return "continue";
                            status_1 = 3;
                        }
                        else if (funct === "void") {
                            status_1 = 4;
                            if (lastActivity.repetitionOrder > 1)
                                lastActivity.repetitionOrder -= 1;
                        }
                        else if (funct === "voidifnotcreated") {
                            if (lastActivity.status != -1)
                                return "continue";
                            status_1 = 4;
                            if (lastActivity.repetitionOrder > 1)
                                lastActivity.repetitionOrder -= 1;
                        }
                        else if (funct === "pause") {
                            status_1 = 5;
                        }
                        else {
                            return "continue";
                        }
                        this_6.activityLogs = __spreadArray(__spreadArray([], this_6.activityLogs, true), [
                            {
                                id: this_6.generateActivityId(),
                                processStepId: lastActivity.processStepId,
                                lineHandlingNo: lastActivity.lineHandlingNo,
                                description: lastActivity.description,
                                logTime: this_6.logTime,
                                state: lastActivity.state,
                                status: status_1,
                                nominationNo: lastActivity.nominationNo,
                                repetitionOrder: lastActivity.repetitionOrder,
                                groupIndex: undefined,
                            },
                        ], false);
                    };
                    for (var _b = 0, distinctNomination_1 = distinctNomination; _b < distinctNomination_1.length; _b++) {
                        var _dNom = distinctNomination_1[_b];
                        _loop_8(_dNom);
                    }
                }
            };
            var this_6 = this, _stepState;
            for (var _i = 0, actions_1 = actions; _i < actions_1.length; _i++) {
                var action = actions_1[_i];
                _loop_7(action);
            }
        }
    };
    SofProcessor.prototype.modifyData = function () {
        if (this.processFlowAction.modifyData) {
            for (var _i = 0, _a = this.processFlowAction.modifyData; _i < _a.length; _i++) {
                var modifyData = _a[_i];
                this.modifyDataI(modifyData.modifyDataConditions, modifyData.modifyData, this.nomination);
            }
        }
    };
    SofProcessor.prototype.modifyDataI = function (conditions, data, nomination) {
        if (nomination === void 0) { nomination = undefined; }
        if (SofProcessor.checkConditions(conditions, this.lineHandling, nomination, this.activityLogs)) {
            this.lineHandling = SofProcessor.applyLineHandlingChanges(this.lineHandling, data);
            if (nomination) {
                var result_1 = SofProcessor.applyNominationChanges(nomination, data);
                if (result_1) {
                    if (nomination.nominationNo ===
                        (this.nomination && this.nomination.nominationNo))
                        this.nomination = result_1;
                    this.lineHandling.nominations = __spreadArray(__spreadArray([], this.lineHandling.nominations.filter(function (f) { return f.nominationNo !== result_1.nominationNo; }), true), [
                        result_1,
                    ], false);
                }
            }
            else {
                var _loop_9 = function (nom) {
                    var result = SofProcessor.applyNominationChanges(nom, data);
                    if (result)
                        this_7.lineHandling.nominations = __spreadArray(__spreadArray([], this_7.lineHandling.nominations.filter(function (f) { return f.nominationNo !== nom.nominationNo; }), true), [
                            result,
                        ], false);
                };
                var this_7 = this;
                for (var _i = 0, _a = this.lineHandling.nominations; _i < _a.length; _i++) {
                    var nom = _a[_i];
                    _loop_9(nom);
                }
            }
            var _loop_10 = function (activityLog) {
                var _actLog = SofProcessor.applyActivityLogChanges(activityLog, data);
                if (_actLog) {
                    this_8.activityLogs = __spreadArray(__spreadArray([], this_8.activityLogs.filter(function (f) { return f.id !== activityLog.id; }), true), [
                        _actLog,
                    ], false);
                    if (this_8.updatedActivityLogs.indexOf(_actLog.id) < 0) {
                        this_8.updatedActivityLogs = __spreadArray(__spreadArray([], this_8.updatedActivityLogs, true), [
                            _actLog.id,
                        ], false);
                    }
                }
            };
            var this_8 = this;
            for (var _b = 0, _c = this.activityLogs; _b < _c.length; _b++) {
                var activityLog = _c[_b];
                _loop_10(activityLog);
            }
        }
    };
    SofProcessor.prototype.updateProgress = function () {
        var _this = this;
        var totalActivities = 0;
        var completedActivities = 0;
        var progress = 0;
        var currentActivities = SofProcessor.getCurrentActivityPerStep(this.activityLogs);
        var finishedStatuses = [2, 3];
        var activeStatuses = [0, 1, 5];
        var _loop_11 = function (nom) {
            var config = this_9.processFlowConfigs.find(function (f) {
                return f.id === nom.processFlowConfigId &&
                    f.version === nom.processFlowConfigVersion;
            });
            if (config === undefined)
                return "continue";
            var currentNominationStep = currentActivities.filter(function (f) {
                return f.nominationNo === nom.nominationNo &&
                    finishedStatuses.indexOf(f.status) >= 0;
            });
            var nomSteps = currentNominationStep.length === 0
                ? 0
                : config.steps
                    .filter(function (f) {
                    return currentNominationStep
                        .map(function (s) { return s.processStepId; })
                        .indexOf(f.id) >= 0;
                })
                    .sort(function (a, b) { return b.order - a.order; })[0].order;
            var maxNominationStep = config.steps.sort(function (a, b) { return b.order - a.order; })[0].order;
            var activeActivityCount = currentActivities.filter(function (f) {
                return f.nominationNo === nom.nominationNo &&
                    activeStatuses.indexOf(f.status) >= 0;
            }).length;
            var nomCompletedActivities = nomSteps - (nomSteps == maxNominationStep ? activeActivityCount : 0);
            completedActivities += nomCompletedActivities;
            totalActivities += maxNominationStep;
            progress = Math.round((nomSteps / config.steps.length) * 100);
            nom.progress = isNaN(progress) ? 0 : progress;
        };
        var this_9 = this;
        for (var _i = 0, _a = this.lineHandling.nominations; _i < _a.length; _i++) {
            var nom = _a[_i];
            _loop_11(nom);
        }
        var lineHandlingConfig = this.processFlowConfigs.find(function (f) {
            return f.id === _this.lineHandling.processFlowConfigId &&
                f.version === _this.lineHandling.processFlowConfigVersion;
        });
        if (lineHandlingConfig === undefined)
            return;
        var lineHandlingSteps = currentActivities.filter(function (f) {
            return f.nominationNo === undefined && finishedStatuses.indexOf(f.status) >= 0;
        });
        var lastFinished = lineHandlingSteps.length === 0
            ? 0
            : lineHandlingConfig.steps
                .filter(function (f) {
                return lineHandlingSteps.map(function (i) { return i.processStepId; }).indexOf(f.id) >= 0;
            })
                .sort(function (a, b) { return b.order - a.order; })[0].order;
        completedActivities += lastFinished;
        totalActivities += lineHandlingConfig.steps.length;
        if (completedActivities == totalActivities) {
            progress = 100;
        }
        else {
            progress = Math.round((completedActivities / totalActivities) * 100);
            if (progress === 100)
                progress = 99;
        }
        this.lineHandling.progress = isNaN(progress) ? 0 : progress;
    };
    SofProcessor.prototype.saveChanges = function () {
        return __awaiter(this, void 0, void 0, function () {
            var originalLineHandling, updatedLineHandling, lineHandlingChanges, updatedNomination, nominationChanges, _loop_12, _i, _a, nom, activityLogsChanges, originalActivityLogs, resultActivities, _loop_13, this_10, _b, _c, updatedActId, changes, isFirst, _d, _e, act;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, PersistentDataService_1.PersistentDataService.getLineHandlingAsync(this.lineHandling.lineHandlingNo)];
                    case 1:
                        originalLineHandling = _f.sent();
                        if (originalLineHandling === undefined)
                            throw new Error("Line Handling not found");
                        updatedLineHandling = {};
                        lineHandlingChanges = SofProcessor.compareLineHandling(this.lineHandling, originalLineHandling, updatedLineHandling);
                        updatedNomination = [];
                        nominationChanges = "";
                        _loop_12 = function (nom) {
                            var compareTo = originalLineHandling.nominations.find(function (f) { return f.nominationNo === nom.nominationNo; });
                            if (compareTo === undefined)
                                return "continue";
                            var individualResult = {};
                            var individualChanges = SofProcessor.compareNomination(nom, compareTo, individualResult);
                            if (individualChanges) {
                                nominationChanges +=
                                    (nominationChanges === "" ? "" : "-\r\n") + individualChanges;
                                updatedNomination = __spreadArray(__spreadArray([], updatedNomination, true), [individualResult], false);
                            }
                        };
                        for (_i = 0, _a = this.lineHandling.nominations; _i < _a.length; _i++) {
                            nom = _a[_i];
                            _loop_12(nom);
                        }
                        activityLogsChanges = "";
                        return [4 /*yield*/, PersistentDataService_1.PersistentDataService.getActivityLogsAsync(this.lineHandling.lineHandlingNo)];
                    case 2:
                        originalActivityLogs = _f.sent();
                        if (originalActivityLogs === undefined)
                            throw new Error("Activity logs for the Line Handling ".concat(this.lineHandling.lineHandlingNo, " not found"));
                        resultActivities = [];
                        _loop_13 = function (updatedActId) {
                            var activityLog = this_10.activityLogs.find(function (f) { return f.id === updatedActId; });
                            var toActivityLog = originalActivityLogs.find(function (f) { return f.id === updatedActId; });
                            if (activityLog === undefined || toActivityLog === undefined)
                                return "continue";
                            var updatedActivity = {};
                            var actChanges = SofProcessor.compareActivityLogs(activityLog, toActivityLog, updatedActivity);
                            resultActivities = __spreadArray(__spreadArray([], resultActivities, true), [activityLog], false);
                            if (actChanges) {
                                activityLogsChanges +=
                                    (activityLogsChanges === "" ? "" : "-\r\n") + actChanges;
                            }
                        };
                        this_10 = this;
                        for (_b = 0, _c = this.updatedActivityLogs; _b < _c.length; _b++) {
                            updatedActId = _c[_b];
                            _loop_13(updatedActId);
                        }
                        changes = [
                            lineHandlingChanges,
                            nominationChanges,
                            activityLogsChanges,
                        ].join("-\r\n");
                        isFirst = true;
                        for (_d = 0, _e = this.activityLogs.filter(function (f) { return f.logTime === _this.logTime; }); _d < _e.length; _d++) {
                            act = _e[_d];
                            if (isFirst) {
                                act.changes = changes;
                                isFirst = false;
                            }
                            act.offline = true;
                            resultActivities = __spreadArray(__spreadArray([], resultActivities, true), [act], false);
                        }
                        if (updatedNomination !== undefined && updatedNomination.length > 0) {
                            updatedLineHandling["nominations"] = updatedNomination;
                        }
                        return [2 /*return*/, {
                                activities: resultActivities,
                                newState: this.newState,
                                result: updatedLineHandling,
                            }];
                }
            });
        });
    };
    SofProcessor.prototype.generateActivityId = function () {
        var linNo = (0, Helper_1.toLineHandlingNo)(this.lineHandling);
        var actCount = this.activityLogs.length + 1;
        return parseInt(linNo + actCount.toString().padStart(6, "0"));
    };
    SofProcessor.undoAsync = function (lineHandlingNo) {
        return __awaiter(this, void 0, void 0, function () {
            var nominationNo, hasChanges, lineHandling, activityLogs, sortedActs, lastTimeStamp, lastActions, _loop_14, _i, lastActions_1, action;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nominationNo = undefined;
                        hasChanges = false;
                        return [4 /*yield*/, PersistentDataService_1.PersistentDataService.getLineHandlingAsync(lineHandlingNo)];
                    case 1:
                        lineHandling = _a.sent();
                        if (lineHandling === undefined)
                            throw new Error("No offline data found for ".concat(lineHandlingNo));
                        return [4 /*yield*/, PersistentDataService_1.PersistentDataService.getActivityLogsAsync(lineHandlingNo)];
                    case 2:
                        activityLogs = _a.sent();
                        if (activityLogs === undefined)
                            throw new Error("No offline activities found for ".concat(lineHandlingNo));
                        sortedActs = activityLogs.sort(function (a, b) { return a.id - b.id; }).reverse();
                        lastTimeStamp = sortedActs[0].logTime;
                        lastActions = activityLogs.filter(function (f) { return f.logTime === lastTimeStamp; });
                        if (lastActions.length === activityLogs.length) {
                            throw new Error("Cannot perform undo further.");
                        }
                        _loop_14 = function (action) {
                            if (action.changes) {
                                nominationNo = action.nominationNo;
                                hasChanges = true;
                                lineHandling = SofProcessor.applyLineHandlingChanges(lineHandling, action.changes);
                                var _loop_15 = function (nom) {
                                    var result = SofProcessor.applyNominationChanges(nom, action.changes);
                                    if (result)
                                        lineHandling.nominations = __spreadArray(__spreadArray([], lineHandling.nominations.filter(function (f) { return f.nominationNo !== nom.nominationNo; }), true), [
                                            result,
                                        ], false);
                                };
                                for (var _b = 0, _c = lineHandling.nominations; _b < _c.length; _b++) {
                                    var nom = _c[_b];
                                    _loop_15(nom);
                                }
                                if (activityLogs) {
                                    var _loop_16 = function (activityLog) {
                                        var _actLog = SofProcessor.applyActivityLogChanges(activityLog, action.changes);
                                        if (_actLog) {
                                            activityLogs = __spreadArray(__spreadArray([], activityLogs.filter(function (f) { return f.id !== activityLog.id; }), true), [
                                                _actLog,
                                            ], false);
                                        }
                                    };
                                    for (var _d = 0, activityLogs_1 = activityLogs; _d < activityLogs_1.length; _d++) {
                                        var activityLog = activityLogs_1[_d];
                                        _loop_16(activityLog);
                                    }
                                }
                            }
                            activityLogs = activityLogs.filter(function (f) { return f.id !== action.id; });
                        };
                        for (_i = 0, lastActions_1 = lastActions; _i < lastActions_1.length; _i++) {
                            action = lastActions_1[_i];
                            _loop_14(action);
                        }
                        if (!hasChanges) return [3 /*break*/, 4];
                        return [4 /*yield*/, PersistentDataService_1.PersistentDataService.saveLineHandling(lineHandling)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, PersistentDataService_1.PersistentDataService.saveActivityLogsAsync(lineHandlingNo, activityLogs.reverse())];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, {
                                lineHandlingNo: lineHandlingNo,
                                nominationNo: nominationNo,
                                logTime: lastTimeStamp,
                            }];
                }
            });
        });
    };
    SofProcessor.getCurrentActivityPerStep = function (activityLogs) {
        var result = [];
        var _loop_17 = function () {
            var filter = result.find(function (f) {
                return f.nominationNo === log.nominationNo &&
                    f.processStepId === log.processStepId &&
                    f.surveyor === log.surveyor &&
                    f.repetitionOrder === log.repetitionOrder;
            });
            if (filter) {
                if (log.id > filter.id) {
                    result = __spreadArray(__spreadArray([], result.filter(function (f) { return f.id !== filter.id; }), true), [log], false);
                }
            }
            else {
                result = __spreadArray(__spreadArray([], result, true), [log], false);
            }
        };
        for (var _i = 0, activityLogs_2 = activityLogs; _i < activityLogs_2.length; _i++) {
            var log = activityLogs_2[_i];
            _loop_17();
        }
        result = result.sort(function (a, b) { return a.processStepId - b.processStepId; });
        return result;
    };
    SofProcessor.prototype.checkConditions = function (str) {
        var _this = this;
        return SofProcessor.checkConditions(str, this.lineHandling, this.nomination, this.activityLogs.filter(function (f) {
            return _this.nomination === undefined ||
                f.nominationNo === _this.nomination.nominationNo;
        }));
    };
    SofProcessor.checkConditions = function (str, lineHandling, nomination, activities) {
        if (str === undefined || str === "")
            return true;
        var conditions = str.split(/\sOR\s|\sAND\s/gm);
        var newStr = str;
        for (var _i = 0, conditions_1 = conditions; _i < conditions_1.length; _i++) {
            var condition = conditions_1[_i];
            var individualResult = false;
            if (condition.trim().startsWith("L:")) {
                if (lineHandling === undefined) {
                    individualResult = false;
                }
                else {
                    individualResult =
                        lineHandling !== undefined &&
                            this.checkLineHandlingConditions(condition.trim().substr(2), lineHandling);
                }
            }
            else if (condition.trim().startsWith("NS:")) {
                individualResult =
                    lineHandling !== undefined &&
                        this.checkNominationsConditions(condition.trim().substr(3), lineHandling);
            }
            else if (condition.trim().startsWith("N:")) {
                if (nomination === undefined) {
                    individualResult = false;
                }
                else {
                    individualResult = this.checkNominationConditions(condition.trim().substr(2), nomination);
                }
            }
            else if (condition.trim().startsWith("A:")) {
                individualResult = this.checkActivitiesConditions(condition.trim().substr(2), activities.filter(function (f) {
                    return nomination === undefined ||
                        f.nominationNo === nomination.nominationNo;
                }));
            }
            else {
                individualResult = false;
            }
            newStr = newStr.replace(condition, " ".concat(individualResult, " "));
        }
        newStr = SofProcessor.replaceOperators(newStr);
        var result = eval(newStr);
        return result;
    };
    SofProcessor.checkConditionsByNomination = function (str, nomination, activities) {
        if (str === undefined || str === "")
            return true;
        var conditions = str.split(/\sOR\s|\sAND\s/gm);
        var newStr = str;
        for (var _i = 0, conditions_2 = conditions; _i < conditions_2.length; _i++) {
            var condition = conditions_2[_i];
            var individualResult = false;
            if (condition.trim().startsWith("N:")) {
                if (nomination === undefined) {
                    individualResult = false;
                }
                else {
                    individualResult = this.checkNominationConditions(condition.trim().substr(2), nomination);
                }
            }
            else if (condition.trim().startsWith("A:")) {
                individualResult = this.checkActivitiesConditions(condition.trim().substr(2), activities.filter(function (f) {
                    return nomination === undefined ||
                        f.nominationNo === nomination.nominationNo;
                }));
            }
            else {
                individualResult = false;
            }
            newStr = newStr.replace(condition, " ".concat(individualResult, " "));
        }
        newStr = SofProcessor.replaceOperators(newStr);
        var result = eval(newStr);
        return result;
    };
    SofProcessor.replaceMergeField = function (str, surveyor, ordinal, vesselType) {
        if (surveyor === void 0) { surveyor = undefined; }
        if (ordinal === void 0) { ordinal = 1; }
        if (vesselType === void 0) { vesselType = "Vessel"; }
        if (str.indexOf("{n}") >= 0) {
            return str.replace("{n}", (0, Helper_1.toOrdinalString)(ordinal));
        }
        else if (str.indexOf("{surveyor}") >= 0) {
            surveyor = surveyor === undefined ? "surveyor" : surveyor;
            return str.replace("{surveyor}", surveyor);
        }
        else if (str.indexOf("{vesseltype}") >= 0) {
            return str.replace("{vesseltype}", vesselType);
        }
        return str;
    };
    SofProcessor.checkLineHandlingConditions = function (str, lineHandling) {
        var fields = Object.keys(lineHandling);
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var f = fields_1[_i];
            var fieldName = f.substr(0, 1).toUpperCase() + f.substr(1);
            var fieldValue = Reflect.get(lineHandling, f);
            if (typeof fieldValue === "number") {
                str = this.replaceAll(str, fieldName, fieldValue.toString());
            }
            else {
                str = this.replaceAll(str, fieldName, "\"".concat(fieldValue, "\""));
            }
        }
        str = this.replaceOperators(str);
        var result = false;
        try {
            result = eval(str);
        }
        catch (_a) { }
        return result;
    };
    SofProcessor.checkNominationsConditions = function (str, lineHandling) {
        var trimmed = str.trim();
        var result = true;
        var regex = /\((.*?)\)/gm;
        var match = [];
        var m;
        while ((m = regex.exec(trimmed.trim())) !== null) {
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            m.forEach(function (mat) { return (match = __spreadArray(__spreadArray([], match, true), [mat], false)); });
        }
        if (match.length > 1) {
            var condition = match[1];
            if (condition) {
                if (trimmed.toLowerCase().startsWith("all")) {
                    for (var _i = 0, _a = lineHandling.nominations; _i < _a.length; _i++) {
                        var nom = _a[_i];
                        var individualResult = this.checkNominationConditions(condition, nom);
                        if (!individualResult) {
                            result = false;
                            break;
                        }
                    }
                }
                else {
                    for (var _b = 0, _c = lineHandling.nominations; _b < _c.length; _b++) {
                        var nom = _c[_b];
                        result = false;
                        var individualResult = this.checkNominationConditions(condition, nom);
                        if (individualResult) {
                            result = true;
                            break;
                        }
                    }
                }
            }
        }
        return result;
    };
    SofProcessor.checkNominationConditions = function (str, nomination) {
        var fields = Object.keys(nomination);
        for (var _i = 0, fields_2 = fields; _i < fields_2.length; _i++) {
            var f = fields_2[_i];
            var fieldName = f.substr(0, 1).toUpperCase() + f.substr(1);
            var fieldValue = Reflect.get(nomination, f);
            if (typeof fieldValue === "number")
                str = this.replaceAll(str, "\\b".concat(fieldName, "\\b"), fieldValue.toString());
            else if (fieldValue === undefined)
                str = this.replaceAll(str, "\\b".concat(fieldName, "\\b"), "null");
            else
                str = this.replaceAll(str, "\\b".concat(fieldName, "\\b"), "\"".concat(fieldValue, "\""));
        }
        str = this.replaceOperators(str);
        var result = false;
        try {
            result = eval(str);
        }
        catch (_a) {
            return false;
        }
        return result;
    };
    SofProcessor.checkActivitiesConditions = function (str, activities) {
        var _a;
        var conditions = str.split(/and|or/);
        var funcStatus = (_a = {},
            _a["created"] = 0,
            _a["started"] = 1,
            _a["done"] = 2,
            _a["skipped"] = 3,
            _a["void"] = 4,
            _a["paused"] = 5,
            _a);
        var lastActivities = SofProcessor.getCurrentActivityPerStep(activities);
        if (lastActivities === undefined)
            return false;
        var _loop_18 = function (condition) {
            var individualResult = false;
            var isLogicalNot = condition.trim().startsWith("!");
            var regex = /\((.*?)\)/gm;
            var match = [];
            var m = void 0;
            while ((m = regex.exec(condition.trim())) !== null) {
                if (m.index === regex.lastIndex) {
                    regex.lastIndex++;
                }
                m.forEach(function (mat) { return (match = __spreadArray(__spreadArray([], match, true), [mat], false)); });
            }
            if (match.length > 1) {
                var stepId_2 = parseInt(match[1]);
                var trimmedCondition = condition.trim().replace("!", "");
                var _loop_19 = function (func) {
                    if (trimmedCondition.startsWith(func)) {
                        var stepActivities = lastActivities.filter(function (f) { return f.processStepId === stepId_2; });
                        if (stepActivities.length > 0) {
                            var maxOrder_1 = stepActivities.sort(function (a, b) { return b.repetitionOrder - a.repetitionOrder; })[0].repetitionOrder;
                            stepActivities = stepActivities.filter(function (f) { return f.repetitionOrder === maxOrder_1; });
                            individualResult = isLogicalNot
                                ? stepActivities.filter(function (f) { return f.status === funcStatus[func]; })
                                    .length > 0
                                : stepActivities.filter(function (f) { return f.status === funcStatus[func]; })
                                    .length === stepActivities.length;
                        }
                        else {
                            individualResult = false;
                        }
                    }
                };
                for (var func in funcStatus) {
                    _loop_19(func);
                }
            }
            individualResult = isLogicalNot ? !individualResult : individualResult;
            str = str.replace(condition, " ".concat(individualResult, " "));
        };
        for (var _i = 0, conditions_3 = conditions; _i < conditions_3.length; _i++) {
            var condition = conditions_3[_i];
            _loop_18(condition);
        }
        str = this.replaceOperators(str);
        var result = eval(str);
        return result;
    };
    SofProcessor.applyLineHandlingChanges = function (lineHandling, changes) {
        var _a;
        if (changes === undefined)
            return lineHandling;
        var groups = changes.split("\r\n-\r\n");
        for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
            var group = groups_1[_i];
            if (!group.trim().startsWith("LineHandling:"))
                continue;
            var lines = group.trim().split("\r\n");
            for (var _b = 0, lines_1 = lines; _b < lines_1.length; _b++) {
                var line = lines_1[_b];
                line = line.trim();
                if (line.indexOf("=") < 0)
                    continue;
                var field = line.substr(0, 1).toLowerCase() +
                    line.substr(1, line.indexOf("=") - 1);
                var value = SofProcessor.evaluateExpression(line.substr(line.indexOf("=") + 1), lineHandling);
                if (value === undefined)
                    continue;
                if (field === "status" || field === "progress") {
                    var numericValue = parseInt(value);
                    value = isNaN(numericValue) ? 0 : numericValue;
                }
                lineHandling = __assign(__assign({}, lineHandling), (_a = {}, _a[field] = value, _a));
            }
        }
        return lineHandling;
    };
    SofProcessor.evaluateExpression = function (exp, object) {
        if (!exp.trim().startsWith("`"))
            return exp;
        var newExp = exp.trim().substr(1);
        var exps = newExp.split(/[+\-*\/]/gm);
        var fields = Object.keys(object);
        for (var _i = 0, exps_1 = exps; _i < exps_1.length; _i++) {
            var ex = exps_1[_i];
            if (ex.length > 1) {
                var localField = ex[0].toLowerCase() + ex.substr(1);
                if (fields.indexOf(localField) > 0) {
                    newExp = newExp.replace(ex, Reflect.get(object, localField));
                }
            }
        }
        try {
            var result = eval(newExp);
            return result;
        }
        catch (_a) {
            return undefined;
        }
    };
    SofProcessor.applyNominationChanges = function (nomination, changes) {
        var _a;
        if (changes === undefined)
            return undefined;
        var hasChanges = false;
        var groups = changes.split("-\r\n");
        for (var _i = 0, groups_2 = groups; _i < groups_2.length; _i++) {
            var group = groups_2[_i];
            if (!group.trim().startsWith("Nomination:"))
                continue;
            var lines = group.trim().split("\r\n");
            var _forNom = lines[0].substr(11);
            if (_forNom !== "" &&
                _forNom.toLowerCase() !== nomination.nominationNo.toLowerCase())
                continue;
            for (var _b = 0, lines_2 = lines; _b < lines_2.length; _b++) {
                var line = lines_2[_b];
                line = line.trim();
                if (line.indexOf("=") < 0)
                    continue;
                var field = line.substr(0, 1).toLowerCase() +
                    line.substr(1, line.indexOf("=") - 1);
                var val = SofProcessor.evaluateExpression(line.substr(line.indexOf("=") + 1), nomination);
                if (val === undefined)
                    continue;
                var value = isNaN(parseInt(val)) ? val : parseInt(val);
                hasChanges = true;
                nomination = __assign(__assign({}, nomination), (_a = {}, _a[field] = value, _a));
            }
        }
        return hasChanges ? nomination : undefined;
    };
    // Apply value changes in an ActivityLog
    // If the changes is not for the activity, return undefined
    SofProcessor.applyActivityLogChanges = function (activityLog, changes) {
        var _a;
        if (changes === undefined)
            return undefined;
        var hasChanges = false;
        var groups = changes.split("\r\n-\r\n");
        for (var _i = 0, groups_3 = groups; _i < groups_3.length; _i++) {
            var group = groups_3[_i];
            if (!group.trim().startsWith("ActivityLog:"))
                continue;
            var lines = group.trim().split("\r\n");
            var _forStepId = lines[0].substr(12);
            if (_forStepId !== activityLog.processStepId.toString())
                continue;
            for (var _b = 0, lines_3 = lines; _b < lines_3.length; _b++) {
                var line = lines_3[_b];
                line = line.trim();
                if (line.indexOf("=") < 0)
                    continue;
                var field = line.substr(0, 1).toLowerCase() +
                    line.substr(1, line.indexOf("=") - 1);
                var value = SofProcessor.evaluateExpression(line.substr(line.indexOf("=") + 1), activityLog);
                if (value === undefined)
                    continue;
                hasChanges = true;
                activityLog = __assign(__assign({}, activityLog), (_a = {}, _a[field] = value, _a));
            }
        }
        return hasChanges ? activityLog : undefined;
    };
    SofProcessor.compareLineHandling = function (subject, to, updates) {
        var result = "";
        var excludedProperties = ["links", "nominations"];
        for (var f in subject) {
            if (Reflect.get(subject, f) !== Reflect.get(to, f) &&
                excludedProperties.indexOf(f) < 0) {
                updates[f] = Reflect.get(subject, f);
                result +=
                    f.substr(0, 1).toUpperCase() +
                        f.substr(1) +
                        "=" +
                        Reflect.get(to, f) +
                        "\r\n";
            }
        }
        if (result === "")
            return undefined;
        else
            return "LineHandling:".concat(subject.lineHandlingNo, "\r\n").concat(result, "\r\n");
    };
    SofProcessor.compareNominations = function (subject, to, updates) {
        var result = "";
        updates = [];
        var _loop_20 = function (nom) {
            var compareTo = to.find(function (f) { return f.nominationNo === nom.nominationNo; });
            if (compareTo === undefined)
                return "continue";
            var individualResult = "";
            var individualUpdates = {};
            for (var f in nom) {
                if (Reflect.get(nom, f) !== Reflect.get(compareTo, f)) {
                    individualUpdates[f] = Reflect.get(nom, f);
                    individualResult +=
                        f.substr(0, 1).toUpperCase() +
                            f.substr(1) +
                            "=" +
                            Reflect.get(compareTo, f) +
                            "\r\n";
                }
            }
            if (individualResult !== "") {
                individualUpdates.nominationNo = nom.nominationNo;
                updates = __spreadArray(__spreadArray([], updates, true), [individualUpdates], false);
                result =
                    (result === "" ? "" : "-\r\n") +
                        "Nomination:".concat(nom.nominationNo, "\r\n").concat(individualResult, "\r\n");
            }
        };
        for (var _i = 0, subject_1 = subject; _i < subject_1.length; _i++) {
            var nom = subject_1[_i];
            _loop_20(nom);
        }
        return result;
    };
    SofProcessor.compareNomination = function (subject, to, updates) {
        var result = "";
        for (var f in subject) {
            if (Reflect.get(subject, f) !== Reflect.get(to, f)) {
                updates[f] = Reflect.get(subject, f);
                result +=
                    f.substr(0, 1).toUpperCase() +
                        f.substr(1) +
                        "=" +
                        Reflect.get(to, f) +
                        "\r\n";
            }
        }
        if (result === "") {
            return undefined;
        }
        else {
            updates.nominationNo = subject.nominationNo;
            return "Nomination:".concat(subject.nominationNo, "\r\n").concat(result, "\r\n");
        }
    };
    SofProcessor.compareActivityLogs = function (subject, to, updates) {
        var result = "";
        for (var f in subject) {
            if (Reflect.get(subject, f) !== Reflect.get(to, f)) {
                updates[f] = Reflect.get(subject, f);
                result +=
                    f.substr(0, 1).toUpperCase() +
                        f.substr(1) +
                        "=" +
                        Reflect.get(to, f) +
                        "\r\n";
            }
        }
        if (result !== "")
            return "ActivityLog:".concat(subject.processStepId, "\r\n").concat(result, "\r\n");
        return undefined;
    };
    SofProcessor.replaceOperators = function (str) {
        str = this.replaceAll(str, " eq ", " === ");
        str = this.replaceAll(str, " neq ", " !== ");
        str = this.replaceAll(str, " or ", " || ");
        str = this.replaceAll(str, " OR ", " || ");
        str = this.replaceAll(str, " and ", " && ");
        str = this.replaceAll(str, " AND ", " && ");
        str = this.replaceAll(str, "NULL", "null");
        str = this.replaceAll(str, ".StartsWith", ".startsWith");
        return str;
    };
    SofProcessor.replaceAll = function (str, find, newValue) {
        return str.replace(new RegExp(find, "g"), newValue);
    };
    SofProcessor.getSurveyors = function (lineHandling) {
        var result = lineHandling.nominations
            .filter(function (f) { return f.surveyor !== "" && f.surveyor !== "no surveyor needed"; })
            .map(function (s) { return s.surveyor; });
        return result;
    };
    return SofProcessor;
}());
exports.SofProcessor = SofProcessor;
//# sourceMappingURL=SofProcessor.js.map